
//@ts-ignore
export const apiRootPath = window ? window.SERVER_DOMAIN : '';
//@ts-ignore
export const wsRootPath = window ? window.WS_DOMAIN : '';
//@ts-ignore
export const s3RootPath = window ? window.S3_DOMAIN : '';
//@ts-ignore
export const chatRootPath = window ? window.CHAT_DOMAIN:'';